// ######################################################################
// ###   M e r g e   T w o   C o n f i g   J S O N s
// ######################################################################

import { addToJson, copyFromOtherJson, deleteFromJson } from './UtilsConfigurations';
import { duplicateFlowService } from '../utils/DuplicateConfigurations';
import {
  account_info, getSubCategoryId, iMsg_bank_logo, link_out, loan, request_payment, split_payment,
} from '../utils/DictionaryManagementUtils';

export default function mergeTwoJSONs(localConfigurations, serverConfigurations) {
  console.log(`debug - localVersion: ${localConfigurations.version} serverVersion: ${serverConfigurations.version}`);
  let modifyConfigurations = { ...serverConfigurations };
  if (!modifyConfigurations.version || modifyConfigurations.version < 1) {
    modifyConfigurations = mergeInitialConfigurations(localConfigurations, serverConfigurations);
  }
  if (modifyConfigurations.version < 2) {
    modifyConfigurations = mergeReferenceSplit(modifyConfigurations);
  }
  if (modifyConfigurations.version < 3) {
    addAccountTransactions(modifyConfigurations);
    addRedirectFromKeyboard(modifyConfigurations);
    setServiceAuthWithinConfigurations(modifyConfigurations);
    mergeEnableKeyboardOnBoarding(modifyConfigurations);
    addDevelopmentScreen(modifyConfigurations);
    addLyHourGapRecipient(modifyConfigurations);
  }
  if (modifyConfigurations.version < 4) {
    removeAccountInfoString(modifyConfigurations);
  }
  if (modifyConfigurations.version < 5) {
    addCustomersCanAddPhoto(modifyConfigurations);
    addSelectReasonReference(modifyConfigurations);
    errorMessagesPermissionToPhotos(modifyConfigurations);
  }
  if (modifyConfigurations.version < 6) {
    addVersionsToClientsConfig(modifyConfigurations);
  }
  if (modifyConfigurations.version < 8) {
    addKeyboardConfigurationStep(modifyConfigurations, localConfigurations);
  }
  if (modifyConfigurations.version < 9) {
    copyPasteReceiptMissing(modifyConfigurations);
    addActivityLastUpdate(modifyConfigurations, serverConfigurations);
  }
  if (modifyConfigurations.version < 10) {
    addDeliverablesConfigurationStep(modifyConfigurations, localConfigurations);
    addViewMoreDetailsPerTransaction(modifyConfigurations);
  }
  if (modifyConfigurations.version < 11) {
    removeDuplicateKeyboardSteps(modifyConfigurations);
    deleteEnterPaymentReasonReference(modifyConfigurations);
  }
  if (modifyConfigurations.version < 12) {
    addAmountPackageHowMuchToTransfer(modifyConfigurations);
    addHotkeyQABIcons(modifyConfigurations);
    addDisplayServicesAsIconsStep(modifyConfigurations);
    addPromotionKeyboardStep(modifyConfigurations, localConfigurations);
    addUserTypeConfigurationStep(modifyConfigurations, localConfigurations);
  }
  if (modifyConfigurations.version < 13) {
    addEnableScanBarcode(modifyConfigurations, localConfigurations);
    addLinkOutFlow(modifyConfigurations, localConfigurations);
  }
  if (modifyConfigurations.version < 14) {
    promotionHotfix(modifyConfigurations);
  }
  if (modifyConfigurations.version < 15) {
    promotionScreen(modifyConfigurations, serverConfigurations);
  }
  if (modifyConfigurations.version < 16) {
    addLoanFlow(modifyConfigurations, localConfigurations);
  }
  if (modifyConfigurations.version < 17) {
    loanFlowHotfix(modifyConfigurations, localConfigurations);
  }

  modifyConfigurations.version = localConfigurations.version;
  return modifyConfigurations;
}

export function loanFlowHotfix(modifyConfigurations, localConfigurations) {
  const { services } = modifyConfigurations.configurations;
  services.screens_ordering = localConfigurations.configurations.services.screens_ordering;
  modifyConfigurations.screensList = localConfigurations.screensList;
  addToJson(services, 'loan_0', {
    ...services.loan_0,
    amount: {
      ...services.loan_0.amount,
      select_currency: false,
      show_account_balance: false,
    },
    option: {
      ...services.loan_0.option,
      select_loan_installment_options: true,
    },
  });
}

export function addLoanFlow(modifyConfigurations, localConfigurations) {
  const { services } = modifyConfigurations.configurations;
  services.screens_ordering = localConfigurations.configurations.services.screens_ordering;
  modifyConfigurations.screensList = localConfigurations.screensList;
  addToJson(services, 'loan_0',
    {
      name: 'Loan',
      sub_category: loan,
      duplication_number: 0,
      selected: false,
      icon: {
        fName: null,
        fUri: null,
        fID: null,
      },
      icon_action_bar: {
        fName: null,
        fUri: null,
        fID: null,
      },
      auth_within: false,
      screens_ordering: [
        'amount',
        'number',
        'source',
        'option',
        'confirmation',
        'success',
      ],
      amount: {
        show_account_balance: false,
        enable_additional_instruction: true,
        select_currency: false,
        how_much_to_transfer: 'Enter total amount',
        enter_loan_amount: 'Enter loan amount',
        please_enter_valid_amount: 'Please enter a valid amount',
        account_balance: 'Account balance',
        select_paying_account: 'Select paying account',
        title: 'Select paying account',
        equivalent_to: 'Equivalent to',
      },
      number: {
        enable_additional_instruction: true,
        enter_number_installments: 'Enter number of installments',
        next: 'Next',
      },
      source: {
        select_loan_source: 'Select loan source',
      },
      option: {
        select_loan_installment_options: true,
        multiple_columns: 'column_1',
        content_aligned_center: 'center',
        select_loan_option: 'Select installment option',
      },
      confirmation: {
        enable_transaction_fee_on_the_recipient: true,
        does_it_look_ok: 'Confirm payment details',
        transaction_fee_is_on_the_recipient: 'Service fee is on the recipient',
        more_details: 'More details',
        confirm: 'Send payment request',
        confirm_loan: 'Confirm loan',
        confirmation_sender_label: 'Your account',
        confirm_loan_details: 'Confirm loan details',
      },
      success: {
        enable_customer_to_share_transaction: true,
        sharing_method: 'receipt',
        enable_customer_to_make_another_transfer: true,
        your_receipt: 'Your receipt',
        share_in_chat: 'Share link',
        share_receipt: 'Share receipt',
        share: 'Share',
        go_back_to_menu: 'Go back to the menu',
        done: 'Done',
        make_another_transfer: 'Go back to the menu',
        copied_now_paste_to_chat: 'Copied, now paste in the chat',
        more_details: 'Show more details',
        close: 'Close',
      },
    });
}

export function promotionScreen(modifyConfigurations, serverConfigurations) {
  if (serverConfigurations.version === 12) {
    modifyConfigurations.configurations.keyboard.screens_ordering.push('promotion');
    modifyConfigurations.screensList.push({
      screen_name: 'promotion',
      category: 'keyboard',
      screen_index: 0,
      step_index: 1,
    });
  }
}

export function promotionHotfix(modifyConfigurations) {
  const { keyboard } = modifyConfigurations.configurations;
  if (!keyboard.promotion) {
    addToJson(keyboard, 'promotion',
      {
        enable_promotion: false,
        empty_state_image: {
          fName: null,
          fUri: null,
          fID: null,
        },
      });
  }
}

export function addEnableScanBarcode(modifyConfigurations, localConfigurations) {
  const { pay_bills_0 } = modifyConfigurations.configurations.services;
  const { select_bill } = pay_bills_0;
  modifyConfigurations.screensList = localConfigurations.screensList;
  addToJson(select_bill, 'enable_customer_to_scan_barcode', false);
  addToJson(select_bill, 'add_new_bill', 'Add new bill');
  addToJson(select_bill, 'scan_barcode', 'Scan barcode');
  addToJson(select_bill, 'type_the_barcode', 'Type the barcode');
  addToJson(select_bill, 'type_the_barcode_title', 'Type the barcode');
  addToJson(select_bill, 'scan_bill_barcode', 'Scan bill barcode');
  addToJson(select_bill, 'invalid_qr', 'Invalid QR');
  addToJson(select_bill, 'try_again', 'Try again');
  addToJson(modifyConfigurations.configurations.launch.empty_state, 'your_bills', 'Your bills');
  deleteFromJson(pay_bills_0, 'screens_ordering');
  addToJson(pay_bills_0, 'screens_ordering',
    [
      'select_bill',
      'confirmation_bill',
      'success',
    ]);
  deleteFromJson(pay_bills_0, 'enter_bill');
}

export function addLinkOutFlow(modifyConfigurations, localConfigurations) {
  const { services } = modifyConfigurations.configurations;
  services.screens_ordering = localConfigurations.configurations.services.screens_ordering;
  addToJson(services, 'link_out_0',
    {
      name: 'Link Out',
      sub_category: link_out,
      duplication_number: 0,
      selected: true,
      icon: {
        fName: null,
        fUri: null,
        fID: null,
      },
      icon_action_bar: {
        fName: null,
        fUri: null,
        fID: null,
      },
      auth_within: false,
      screens_ordering: [
        'link_out',
      ],
      link_out: {},
    });
  modifyConfigurations.screensList.push({
    screen_name: 'link_out',
    category: 'services',
    sub_category: 'link_out',
    step: 'link_out',
    duplication_number: 0,
    screen_index: 0,
    step_index: 0,
  });
}

export function addHotkeyQABIcons(modifyConfigurations) {
  addToJson(modifyConfigurations.configurations.services.menu, 'hotkey_qab', {
    fName: null,
    fUri: null,
    fID: null,
  });
  modifyConfigurations.configurations.services.screens_ordering.forEach((serviceKey) => {
    const service = modifyConfigurations.configurations.services[serviceKey];
    const { success } = service;
    if (success) {
      addToJson(success, 'done', 'Done');
    }
  });
}

export function addPromotionKeyboardStep(modifyConfigurations, localConfigurations) {
  addToJson(modifyConfigurations.configurations.keyboard, 'promotion',
    localConfigurations.configurations.keyboard.promotion);
  modifyConfigurations.screensList.push({
    screen_name: 'promotion',
    category: 'keyboard',
    screen_index: 0,
    step_index: 1,
  });
}

export function removeDuplicateKeyboardSteps(modifyConfigurations) {
  const temp_screenList = [...modifyConfigurations.screensList];
  let is_displayed_twice = false;
  let start_cut_index = 0;
  temp_screenList.forEach((screen, index) => {
    if (screen.screen_name === 'keyboard_language') {
      if (!is_displayed_twice) {
        is_displayed_twice = true;
        start_cut_index = index + 1;
      } else {
        modifyConfigurations.screensList.splice(start_cut_index, 1);
      }
    }
  });
}

function deleteEnterPaymentReasonReference(modifyConfigurations) {
  const { services } = modifyConfigurations.configurations;
  services.screens_ordering
    .filter((serviceKey) => services[serviceKey].sub_category === request_payment || services[serviceKey].sub_category === split_payment)
    .forEach((serviceKey) => {
      const { reference } = services[serviceKey];
      if (reference) {
        deleteFromJson(reference, 'enter_payment_reason');
      }
    });
}

function addAmountPackageHowMuchToTransfer(modifyConfigurations) {
  modifyConfigurations.configurations.services.screens_ordering.forEach((serviceKey) => {
    const service = modifyConfigurations.configurations.services[serviceKey];
    const { amount_package } = service;
    if (amount_package) {
      addToJson(amount_package, 'how_much_to_transfer', 'Enter total amount');
    }
  });
}

export function addDeliverablesConfigurationStep(modifyConfigurations, localConfigurations) {
  const { services } = modifyConfigurations.configurations;
  const { menu } = services;
  modifyConfigurations.configurations.screens_ordering = localConfigurations.configurations.screens_ordering;
  addToJson(modifyConfigurations.configurations, 'deliverables',
    localConfigurations.configurations.deliverables);
  modifyConfigurations.screensList.push({
    screen_name: 'deliverables',
    category: 'deliverables',
  });
  deleteFromJson(menu, 'iMsg_enabled');
  deleteFromJson(menu, 'redirect_from_keyboard_enabled');
}

export function addDisplayServicesAsIconsStep(modifyConfigurations) {
  const { services } = modifyConfigurations.configurations;
  const { menu } = services;
  const { keyboard } = modifyConfigurations.configurations.launch;
  deleteFromJson(keyboard, 'keyboard_logo');
  deleteFromJson(keyboard, 'keyboard_disabled_logo');
  addToJson(menu, 'layout_menu_screen', true);
  addToJson(menu, 'keyboard_logo', {
    fName: null,
    fUri: null,
    fID: null,
  });
  addToJson(menu, 'keyboard_disabled_logo', {
    fName: null,
    fUri: null,
    fID: null,
  });
  services.screens_ordering.forEach((serviceKey) => {
    addToJson(services[serviceKey], 'icon_action_bar', {
      fName: null,
      fUri: null,
      fID: null,
    });
  });
}

export function addUserTypeConfigurationStep(modifyConfigurations, localConfigurations) {
  modifyConfigurations.configurations.deliverables.screens_ordering = localConfigurations.configurations.deliverables.screens_ordering;
  addToJson(modifyConfigurations.configurations.deliverables, 'screens_ordering',
    localConfigurations.configurations.deliverables.screens_ordering);

  addToJson(modifyConfigurations.configurations.deliverables, 'user_types',
    localConfigurations.configurations.deliverables.user_types);

  const user_type_screen = {
    screen_name: 'user_types',
    category: 'deliverables',
    screen_index: 0,
    step_index: 1,
  };
  if (!modifyConfigurations.screensList.includes(user_type_screen)) {
    modifyConfigurations.screensList.push(user_type_screen);
  }
}

function copyPasteReceiptMissing(modifyConfigurations) {
  modifyConfigurations.configurations.services.screens_ordering.forEach((serviceKey) => {
    const service = modifyConfigurations.configurations.services[serviceKey];
    const { recipient } = service;
    const { success } = service;
    if (recipient) {
      deleteFromJson(recipient, 'copied_now_paste_to_chat');
    }
    if (success) {
      addToJson(success, 'copied_now_paste_to_chat', 'Copied, now paste in the chat');
      addToJson(success, 'share', 'Share');
    }
  });
}

function addActivityLastUpdate(modifyConfigurations, serverConfigurations) {
  const {
    last_save_at,
    saved_by,
    last_send_at,
    sent_by,
  } = serverConfigurations;
  addToJson(modifyConfigurations, 'last_sdk_created_at', 'Never created');
  addToJson(modifyConfigurations, 'sdk_created_by', '');
  addToJson(modifyConfigurations, 'last_updated_at', last_save_at || 'Not saved yet');
  addToJson(modifyConfigurations, 'updated_by', saved_by || '');
  addToJson(modifyConfigurations, 'last_published_at', last_send_at || 'Never published');
  addToJson(modifyConfigurations, 'published_by', sent_by || '');
  deleteFromJson(modifyConfigurations, 'sent_by');
  deleteFromJson(modifyConfigurations, 'last_send_at');
  deleteFromJson(modifyConfigurations, 'saved_by');
  deleteFromJson(modifyConfigurations, 'last_save_at');
}

function addViewMoreDetailsPerTransaction(modifyConfigurations) {
  const { services } = modifyConfigurations.configurations;
  services.screens_ordering
    .filter((serviceKey) => services[serviceKey].sub_category === account_info)
    .forEach((serviceKey) => {
      addToJson(services[serviceKey], 'transactions/enable_more_details_per_transaction', false);
      addToJson(services[serviceKey], 'transactions/show_link_transactions_list', true);
      addToJson(services[serviceKey], 'transactions/transaction_details', 'Transaction details');
      addToJson(services[serviceKey], 'transactions/confirm_action', 'Confirm action');
      addToJson(services[serviceKey], 'transactions/go_account_balance', 'Go back to your account balance');
      deleteFromJson(services[serviceKey], 'transactions/no_transactions_result');
    });
}

export function addKeyboardConfigurationStep(modifyConfigurations, localConfigurations) {
  modifyConfigurations.configurations.screens_ordering = localConfigurations.configurations.screens_ordering;
  addToJson(modifyConfigurations.configurations, 'keyboard',
    localConfigurations.configurations.keyboard);
  modifyConfigurations.screensList.push({
    screen_name: 'keyboard_language',
    category: 'keyboard',
  });
}

function errorMessagesPermissionToPhotos(modifyConfigurations) {
  const { error_messages } = modifyConfigurations.configurations.launch;
  addToJson(error_messages, 'permission_to_photos_icon', {
    fName: null,
    fUri: null,
    fID: null,
  });
  addToJson(error_messages, 'error_message_permission_to_photos', 'Let “Bank app” access to your photos');
  addToJson(error_messages, 'take_me_to_settings', 'Take me to Settings');
}

function addCustomersCanAddPhoto(modifyConfigurations) {
  modifyConfigurations.configurations.services.screens_ordering.forEach((serviceKey) => {
    const service = modifyConfigurations.configurations.services[serviceKey];
    const { reference } = service;
    if (reference) {
      addToJson(reference, 'customers_add_photo_enabled', false);
      addToJson(reference, 'add_a_reference', 'Add a reference');
      addToJson(reference, 'select_a_photo', 'Select a photo');
      deleteFromJson(reference, 'make_it_personal');
    }
  });
}

function addSelectReasonReference(modifyConfigurations) {
  const { services } = modifyConfigurations.configurations;
  services.screens_ordering
    .filter((serviceKey) => services[serviceKey].sub_category === request_payment || services[serviceKey].sub_category === split_payment)
    .forEach((serviceKey) => {
      const { reference } = services[serviceKey];
      if (reference) {
        addToJson(reference, 'select_reason_from_options', true);
        addToJson(reference, 'custom_reason', true);
        addToJson(reference, 'select_payment_reason', 'Select payment reason');
        addToJson(reference, 'custom', 'Custom');
        addToJson(reference, 'enter_payment_reason', 'Add a note (opt.)');
      }
    });
}

function addVersionsToClientsConfig(modifyConfigurations) {
  addToJson(modifyConfigurations, 'last_save_at', '');
  addToJson(modifyConfigurations, 'saved_by', '');
  addToJson(modifyConfigurations, 'sent_by', '');
  addToJson(modifyConfigurations, 'web_tool_version', 0);
  addToJson(modifyConfigurations, 'firebase_version', 0);
  addToJson(modifyConfigurations, 'firebase_version_path', '');
  addToJson(modifyConfigurations.configurations.general, 'bank_name', modifyConfigurations.bank_name);
}

function removeAccountInfoString(modifyConfigurations) {
  const { services } = modifyConfigurations.configurations;
  services.screens_ordering
    .filter((serviceKey) => services[serviceKey].sub_category === account_info)
    .forEach((serviceKey) => {
      deleteFromJson(services[serviceKey], 'balance/select_paying_account');
      deleteFromJson(services[serviceKey], 'balance/title');
    });
}

function addAccountTransactions(modifyConfigurations) {
  modifyConfigurations.configurations.services.screens_ordering
    .filter((serviceKey) => modifyConfigurations.configurations.services[serviceKey].sub_category === account_info)
    .forEach((serviceKey) => {
      addToJson(modifyConfigurations.configurations.services[serviceKey], 'transactions', {
        no_transactions_result: 'No results',
      });
    });
}

function setServiceAuthWithinConfigurations(modifyConfigurations) {
  modifyConfigurations.configurations.services.screens_ordering.forEach((serviceKey) => {
    addToJson(modifyConfigurations.configurations.services[serviceKey], 'auth_within', false);
  });
  return modifyConfigurations;
}

function addRedirectFromKeyboard(modifyConfigurations) {
  addToJson(modifyConfigurations.configurations.services.menu, 'redirect_from_keyboard_enabled', false);
}

function mergeEnableKeyboardOnBoarding(modifyConfigurations) {
  addToJson(modifyConfigurations.configurations.onboarding.instructions, 'enable_keyboard_with_string', true);
}

function addLyHourGapRecipient(modifyConfigurations) {
  modifyConfigurations.configurations.services.screens_ordering.forEach((serviceKey) => {
    const service = modifyConfigurations.configurations.services[serviceKey];
    const { recipient } = service;
    if (recipient) {
      addToJson(recipient, 'contact_image', 'plus_sign');
      addToJson(recipient, 'skip_contact_list_when_empty', false);
    }
  });
}

function addDevelopmentScreen(modifyConfigurations) {
  modifyConfigurations.configurations.screens_ordering.push('development');
  modifyConfigurations.screensList.push({
    screen_name: 'development_configurations',
    category: 'development',
  });
}

function mergeReferenceSplit(modifyConfigurations) {
  modifyConfigurations.configurations.services.screens_ordering
    .filter((serviceKey) => modifyConfigurations.configurations.services[serviceKey].sub_category === split_payment)
    .forEach((serviceKey) => {
      deleteFromJson(modifyConfigurations.configurations.services[serviceKey].reference, 'select_reason_from_options');
      deleteFromJson(modifyConfigurations.configurations.services[serviceKey].reference, 'custom_reason');
      deleteFromJson(modifyConfigurations.configurations.services[serviceKey].reference, 'select_payment_reason');
      deleteFromJson(modifyConfigurations.configurations.services[serviceKey].reference, 'custom');
      deleteFromJson(modifyConfigurations.configurations.services[serviceKey].reference, 'enter_payment_reason');
    });
  return modifyConfigurations;
}

function mergeInitialConfigurations(localConfigurations, serverConfigurations) {
  const modifyConfigurations = { ...localConfigurations };

  addColorsFromOldJson(modifyConfigurations, serverConfigurations);
  addIconsFromOldJson(modifyConfigurations, serverConfigurations);
  addSelectServicesFromOldJson(modifyConfigurations, serverConfigurations);
  setServiceMenuConfigurations(modifyConfigurations, serverConfigurations);

  return modifyConfigurations;
}

function addColorsFromOldJson(modifyConfigurations, serverConfigurations) {
  const colorsList = ['primary_font_color', 'secondary_font_color', 'primary_font_color', 'secondary_font_color', 'tertiary_icons_color', 'cta_font_color',
    'links_icons_color', 'menu_primary_color', 'menu_secondary_color', 'primary_cta_color', 'disabled_cta_color', 'pressed_cta_color', 'border_color',
    'border_light_color', 'light_elements_color', 'menu_top_area_color', 'menu_balance_color', 'app_background_color', 'positive_color', 'negative_color'];
  colorsList.forEach((color) => {
    copyFromOtherJson(modifyConfigurations.configurations.theme.colors, color, serverConfigurations.options, `${color}/value`);
  });
  [...Array(4)
    .keys()].forEach((index) => {
    copyFromOtherJson(modifyConfigurations.configurations.theme.colors, `avatar_color_${index + 1}`,
      serverConfigurations.options, `avatar_${index + 1}_color/value`);
  });
}

function addIconsFromOldJson(modifyConfigurations, serverConfigurations) {
  const theme = ['custom_font', 'custom_bold_font'];
  const servicesMenu = ['bank_logo', 'iMsg_bank_logo'];
  const launchKeyboard = ['no_results_image', 'bank_logo', 'keyboard_logo', 'keyboard_disabled_logo'];
  const launchErrorMessages = ['no_landscape_icon', 'transaction_failed_icon', 'no_connection_icon', 'general_error_icon'];
  const launchEmptyState = ['empty_state_icon'];
  const onboardingAnnouncement = ['kbd_announcement_icon'];
  const onboardingPromotion = ['menu_screenshot', 'onboarding_big_stickers', 'onboarding_small_stickers'];
  const onboardingInstructions = ['kbd_come_back_icon', 'kbd_success_icon'];
  const general = ['success_image', 'verify_recipient_icon', 'img_arrow_right_button'];

  theme.forEach((iconName) => {
    copyFromOtherJson(modifyConfigurations.configurations.theme.fonts, iconName, serverConfigurations.options, iconName);
  });
  servicesMenu.forEach((iconName) => {
    if (iconName === 'iMsg_bank_logo') {
      copyFromOtherJson(modifyConfigurations.configurations.services.menu, iconName, serverConfigurations.options, iMsg_bank_logo);
    } else {
      copyFromOtherJson(modifyConfigurations.configurations.services.menu, iconName, serverConfigurations.options, iconName);
    }
  });
  modifyConfigurations.configurations.services.screens_ordering.forEach((serviceKey) => {
    copyFromOtherJson(modifyConfigurations.configurations.services[serviceKey], 'icon', serverConfigurations.options, `${serviceKey}/icon`);
  });
  launchKeyboard.forEach((iconName) => {
    copyFromOtherJson(modifyConfigurations.configurations.launch.keyboard, iconName, serverConfigurations.options, iconName);
  });
  launchErrorMessages.forEach((iconName) => {
    copyFromOtherJson(modifyConfigurations.configurations.launch.error_messages, iconName, serverConfigurations.options, iconName);
  });
  launchEmptyState.forEach((iconName) => {
    copyFromOtherJson(modifyConfigurations.configurations.launch.error_messages, iconName, serverConfigurations.options, iconName);
  });
  onboardingAnnouncement.forEach((iconName) => {
    copyFromOtherJson(modifyConfigurations.configurations.onboarding.announcement, iconName, serverConfigurations.options, iconName);
  });
  onboardingPromotion.forEach((iconName) => {
    copyFromOtherJson(modifyConfigurations.configurations.onboarding.promotion, iconName, serverConfigurations.options, iconName);
  });
  onboardingInstructions.forEach((iconName) => {
    copyFromOtherJson(modifyConfigurations.configurations.onboarding.instructions, iconName, serverConfigurations.options, iconName);
  });
  general.forEach((iconName) => {
    copyFromOtherJson(modifyConfigurations.configurations.general, iconName, serverConfigurations.options, iconName);
  });
}

function addSelectServicesFromOldJson(modifyConfigurations, serverConfigurations) {
  addDuplicateFlow(modifyConfigurations, serverConfigurations);
  modifyConfigurations.configurations.services.screens_ordering.forEach((serviceKey) => {
    const service = modifyConfigurations.configurations.services[serviceKey];
    copyFromOtherJson(service, 'selected',
      serverConfigurations.options.select_services.value.filter((serviceOld) => serviceOld.key === serviceKey)[0], 'selected');
    copyFromOtherJson(service, 'name',
      serverConfigurations.textsDict, `${serviceKey}/name`);

    const { recipient } = service;
    if (recipient) {
      const recipientStringKeys = [
        'select_contact_title',
        'select_recipient_details_type',
        'no_results',
        'search_contact_hint',
        'search_contact',
        'amount_participant_title',
        'total_payment',
        'copied_now_paste_to_chat',
        'recipient_information',
        'cancel'];
      recipientStringKeys.forEach((recipientKey) => {
        copyFromOtherJson(recipient, recipientKey,
          serverConfigurations.textsDict, `${serviceKey}/${recipientKey}`);
      });
      recipient.screens_ordering.forEach((manual_recipient, index) => {
        Object.keys(recipient.manual_recipients[manual_recipient])
          .forEach((manualField) => {
            if (typeof recipient.manual_recipients[manual_recipient][manualField] === 'string') {
              copyFromOtherJson(recipient.manual_recipients[manual_recipient], manualField,
                serverConfigurations.textsDict, `${serviceKey}/${manualField}`);
            }
          });
        copyFromOtherJson(recipient.manual_recipients[manual_recipient], 'selected',
          serverConfigurations.options, `${serviceKey}/select_xfer_to_methods/value/${index}/selected`);
      });
    }

    const { amount } = service;
    if (amount) {
      const amountKeys = [
        'how_much_to_transfer',
        'please_enter_valid_amount',
        'account_balance',
        'select_paying_account',
        'title',
        'equivalent_to'];
      amountKeys.forEach((amountKey) => {
        copyFromOtherJson(amount, amountKey,
          serverConfigurations.textsDict, `${serviceKey}/${amountKey}`);
      });
    }

    const { reference } = service;
    if (reference) {
      const referenceKeys = [
        'payment_reason',
        'next',
        'make_it_personal',
        'enter_free_text'];
      referenceKeys.forEach((referenceKey) => {
        copyFromOtherJson(reference, referenceKey,
          serverConfigurations.textsDict, `${serviceKey}/${referenceKey}`);
      });
    }

    const confirmation = service.confirmation || service.confirmation_split;
    if (confirmation) {
      const confirmationKeys = [
        'does_it_look_ok',
        'transaction_fee_is_on_the_recipient',
        'more_details',
        'confirm',
        'confirmation_sender_label'];
      confirmationKeys.forEach((confirmationKey) => {
        copyFromOtherJson(confirmation, confirmationKey,
          serverConfigurations.textsDict, `${serviceKey}/${confirmationKey}`);
      });
    }

    const { success } = service;
    if (success) {
      const successKeys = [
        'sharing_method',
        'your_receipt',
        'share_in_chat',
        'share_receipt',
        'go_back_to_menu',
        'make_another_transfer',
        'more_details',
        'close'];
      successKeys.forEach((successKey) => {
        copyFromOtherJson(success, successKey,
          serverConfigurations.textsDict, `${serviceKey}/${successKey}`);
      });
    }

    const { operator } = service;
    if (operator) {
      const operatorKeys = [
        'design_the_layout',
        'select_mobile_operator_title'];
      operatorKeys.forEach((operatorKey) => {
        copyFromOtherJson(operator, operatorKey,
          serverConfigurations.textsDict, `${serviceKey}/${operatorKey}`);
      });
    }

    const { balance } = service;
    if (balance) {
      const balanceKeys = [
        'account_balance',
        'select_paying_account',
        'title'];
      balanceKeys.forEach((balanceKey) => {
        copyFromOtherJson(balance, balanceKey,
          serverConfigurations.textsDict, `${serviceKey}/${balanceKey}`);
      });
    }

    const { select_bill } = service;
    if (select_bill) {
      const select_billKeys = [
        'your_bills',
        'pay_now',
        'insert_another_bill',
        'how_much_to_transfer',
        'account_balance',
        'select_paying_account',
        'title'];
      select_billKeys.forEach((select_billKey) => {
        copyFromOtherJson(select_bill, select_billKey,
          serverConfigurations.textsDict, `${serviceKey}/${select_billKey}`);
      });
    }

    const { enter_bill } = service;
    if (enter_bill) {
      const enter_billKeys = [
        'type_the_barcode',
        'barcode'];
      enter_billKeys.forEach((enter_billKey) => {
        copyFromOtherJson(enter_bill, enter_billKey,
          serverConfigurations.textsDict, `${serviceKey}/${enter_billKey}`);
      });
    }

    const { confirmation_bill } = service;
    if (confirmation_bill) {
      const confirmation_billKeys = [
        'does_it_look_ok',
        'more_details',
        'confirm_payment',
        'go_back_to_menu',
        'payment_date',
        'today',
        'close'];
      confirmation_billKeys.forEach((confirmation_billKey) => {
        copyFromOtherJson(confirmation_bill, confirmation_billKey,
          serverConfigurations.textsDict, `${serviceKey}/${confirmation_billKey}`);
      });
    }
  });
}

function addDuplicateFlow(modifyConfigurations, serverConfigurations) {
  if (serverConfigurations.options.select_services) {
    const duplicatesFlowFromServer = serverConfigurations.options.select_services.value.filter((serviceOld) => serviceOld.duplication_number > 0);
    duplicatesFlowFromServer.forEach((duplicate) => {
      const basicFlow = modifyConfigurations.configurations.services[getSubCategoryId({
        sub_category: duplicate.sub_category,
        duplication_number: 0,
      })];
      duplicateFlowService(modifyConfigurations, basicFlow, basicFlow.name);
    });
  }
}

function setServiceMenuConfigurations(modifyConfigurations, serverConfigurations) {
  const serviceMenuKeys = [
    'welcome_title',
    'show_account_balance',
    'auth_upon_tapping_the_bank_icon',
    'icon_shape_bars_enam',
  ];

  serviceMenuKeys.forEach((key) => {
    copyFromOtherJson(modifyConfigurations.configurations.services.menu, key,
      serverConfigurations.options, `${key}/value`);
  });
}
